/* @flow */

import { combineReducers } from 'redux';

import appReducer from './appReducer';
import domainReducer from './domainReducer';
import uiReducer from './uiReducer';
import { apiRoot } from 'src/shared/app/base/api/apiRoot';

// $FlowIssue
export default combineReducers({
  app: appReducer,
  domain: domainReducer,
  ui: uiReducer,
  [apiRoot.reducerPath]: apiRoot.reducer,
});
